import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Accordion, Badge } from 'react-bootstrap'
import Card from '../../../components/Card'
import { useNavigate } from 'react-router-dom'
import { apiHandler } from '../../../api/apihandler';
import { TEACHERS_QUESTION_DELETE_API, TEACHERS_QUESTION_OPTION_DELETE_API, TEACHERS_QUESTIONS_LIST_API, TEACHERS_QUESTIONS_OPTION_UPDATE_API, TEACHERS_QUESTIONS_PUBLISH_API, TEACHERS_QUESTIONS_UPDATE_API, TEACHERS_TEST_DELETE_API, TEACHERS_TEST_PRINT_API } from "../../../api/constants";
import { InView } from "react-intersection-observer";
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import NoDataFound from '../../../components/noDataFound';
import ShareModal from '../../../components/ai/ShareModal';
import Swal from 'sweetalert2'
import { FaRegQuestionCircle } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const questionTypeColors = {
    MCQ: "#1976d2",
    SAQ: "#43a047",
    LAQ: "#f9a825",
    NWQ: "#fcbf4a"
};

const typeLabels = {
    MCQ: "MCQs",
    SAQ: "Short Questions",
    LAQ: "Long Questions",
    NWQ: "Non Weighted Questions"
};

const QuestionsList = () => {
    const navigate = useNavigate();
    const [aiResponseList, setAiResponseList] = useState([]);
    const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
    const [isFirst, setIsFirst] = useState(true);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);

    const [editQuestionId, setEditQuestionId] = useState(null);
    const [editQuestionText, setEditQuestionText] = useState("");
    const [editOptionId, setEditOptionId] = useState(null);
    const [editOptionText, setEditOptionText] = useState("");
    const [addOptionQuestionId, setAddOptionQuestionId] = useState(null);
    const [addOptionText, setAddOptionText] = useState("");

    const [showShareModal, setShowShareModal] = useState(false);
    const [shareModalData, setShareModalData] = useState({});
    const [classId, setClassId] = useState('');
    const handleSahreModalShow = () => setShowShareModal(true);
    const handleClose = () => setShowShareModal(false);

    const [editTestDateId, setEditTestDateId] = useState(null);
    const [editTestDateValue, setEditTestDateValue] = useState(null);
 
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setIsFirst(false)
    }, [isFirst]);

    useEffect(() => {
        getResponseListApi(1);
    }, []);

    const loadMore = (inView) => {
        if (inView && page < maxPage) {
            getResponseListApi(page + 1)
            setPage(page + 1)
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        return d.toLocaleString();
    };

    function refreshApi() {
        setPage(1)
        getResponseListApi(1)
    }

    const handleTestDateChange = (search) => {
        Swal.fire({
            title: 'Change Test Date',
            html: `
            <input type="date" id="swal-input-date" class="swal2-input" value="${search.test_details.test_date ? search.test_details.test_date : ''}" style="width: 70%; font-size: 16px;" />
        `,
            showCancelButton: true,
            confirmButtonText: 'Save',
            cancelButtonText: 'Cancel',
            preConfirm: () => {
                const date = document.getElementById('swal-input-date').value;
                if (!date) {
                    Swal.showValidationMessage('Please select a date');
                }
                return date;
            }
        }).then(result => {
            if (result.isConfirmed && result.value) {
                updateTestDateApi(search.ai_search_id, result.value, search.test_details.is_publish);
            }
        });
    };

    async function getResponseListApi(pageVal) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_QUESTIONS_LIST_API, "POST", {
                page: pageVal,
                limit: 10,
                purpose: "test",
            })
            setMaxPage(res?.data?.data?.meta?.last_page)
            if (res.data?.response?.status === 200) {
                if (pageVal === 1) {
                    setAiResponseList(res?.data?.data?.grades || []);
                } else {
                    setAiResponseList(prev => prev.concat(res?.data?.data?.grades || []))
                }
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getQuestionUpdateApi(qId, qText) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_QUESTIONS_UPDATE_API, "POST", {
                question_id: qId,
                question_text: qText
            })
            if (res.data?.response?.status === 200) {
                refreshApi()
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.data?.response?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowMoreDataLoader(false)
        }
    }

    async function updateTestDateApi(aiSearchId, newDate, isPublish) {
        setShowMoreDataLoader(true);
        try {
            const res = await apiHandler(TEACHERS_QUESTIONS_PUBLISH_API, "POST", {
                ai_search_id: aiSearchId,
                test_date: newDate,
                is_publish: isPublish
            });
            if (res.data?.response?.status === 200) {
                refreshApi();
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.data?.response?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowMoreDataLoader(false);
        }
    }

    async function getQuestionDeleteApi(qId) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_QUESTION_DELETE_API, "DELETE", {
                question_id: qId,
            })
            if (res.data?.response?.status === 200) {
                refreshApi()
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.data?.response?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getQuestionOptionAddUpdateApi(qId, qOptionId, qOptionText, type) {
        setShowMoreDataLoader(true)
        let payload = null;
        if (type === "add") {
            payload = { question_id: qId, option_text: qOptionText }
        } else if (type === "update") {
            payload = { question_id: qId, option_id: qOptionId, option_text: qOptionText }
        }
        try {
            const res = await apiHandler(TEACHERS_QUESTIONS_OPTION_UPDATE_API, "POST", payload)
            if (res.data?.response?.status === 200) {
                refreshApi()
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.data?.response?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getQuestionOptionDeleteApi(qId, optionId) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_QUESTION_OPTION_DELETE_API, "DELETE", {
                // question_id: qId,
                option_id: optionId
            })
            if (res.data?.response?.status === 200) {
                refreshApi()
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.data?.response?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowMoreDataLoader(false)
        }
    }

    async function homeworkPublishApi(aiSearchId, testDate, isPublish) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_QUESTIONS_PUBLISH_API, "POST", {
                ai_search_id: aiSearchId,
                test_date: testDate,
                is_publish: isPublish,
            })
            if (res.data?.response?.status === 200) {
                refreshApi()
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.data?.response?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getTestDeleteApi(aiSearchId) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_TEST_DELETE_API, "DELETE", {
                ai_search_id: aiSearchId
            })
            if (res.data?.response?.status === 200) {
                refreshApi()
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.data?.response?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getTestPrintApi(aiSearchId) {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_TEST_PRINT_API, "POST", {
                ai_search_id: aiSearchId
            })
            if (res.data?.response?.status === 200) {
                window.open(res?.data?.data?.url, '_blank');
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.data?.response?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowMoreDataLoader(false)
        }
    }

    // Option pills rendering with white and grey colors
    const renderOptions = (options, qId) => {
        if (!options) return null;
        let optsArr = [];

        // Support MCQ options as array, stringified array, or mcq_options property
        if (Array.isArray(options)) {
            optsArr = options;
        } else if (typeof options === "string" && options.startsWith('[') && options.endsWith(']')) {
            try {
                optsArr = JSON.parse(options);
            } catch {
                optsArr = [];
            }
        } else if (options && typeof options === "object" && Array.isArray(options.mcq_options)) {
            optsArr = options.mcq_options;
        }

        if (!optsArr.length) return null;

        return (
            <div className="question-options-list mt-2 mb-1">
                {optsArr.map((opt, i) => {
                    let text = "";
                    let optionId = i;
                    let isCorrect = false;
                    if (typeof opt === "object" && opt !== null) {
                        text = opt.option_text || opt.text || "";
                        optionId = opt.id !== undefined ? opt.id : i;
                        isCorrect = !!opt.is_correct;
                    } else {
                        text = opt.replace(/^[A-D][\.\)]\s*/, '');
                    }
                    const label = String.fromCharCode(65 + i) + ".";
                    return (
                        <div
                            key={i}
                            className="option-pill-new d-flex align-items-center"
                            style={{
                                background: isCorrect ? "#ffffffff" : "#ffffffff", // Light green for correct, light grey for others
                                fontWeight: isCorrect ? 600 : 400,
                                color: isCorrect ? "#2e7d32" : "#616161", // Dark green for correct, grey for others
                                marginBottom: 8,
                                padding: "8px 12px",
                                borderRadius: 6,
                                border: isCorrect ? "1px solid #e7e7e7ff" : "1px solid #e7e7e7ff"
                            }}
                        >
                            <span className="option-label-new" style={{ 
                                fontWeight: 600,
                                color: isCorrect ? "#1b5e20" : "#424242"
                            }}>
                                {label}
                            </span>
                            {editOptionId === `${qId}_${optionId}` ? (
                                <>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={editOptionText}
                                        onChange={e => setEditOptionText(e.target.value)}
                                        style={{ maxWidth: 180, marginRight: 12, marginLeft: 8 }}
                                    />
                                    <button
                                        className="btn btn-sm btn-success me-2"
                                        style={{ minWidth: 40, fontSize: 18 }}
                                        onClick={() => {
                                            getQuestionOptionAddUpdateApi(qId, optionId, editOptionText, "update");
                                            setEditOptionId(null);
                                        }}
                                    >
                                        <i className="ri-save-line"></i>
                                    </button>
                                    <button
                                        className="btn btn-sm btn-secondary"
                                        style={{ minWidth: 40, fontSize: 18 }}
                                        onClick={() => setEditOptionId(null)}
                                    >
                                        <i className="ri-close-line"></i>
                                    </button>
                                </>
                            ) : (
                                <>
                                    <span className="option-text-new" style={{ 
                                        marginLeft: 8,
                                        color: isCorrect ? "#2e7d32" : "#616161"
                                    }}>
                                        {text}
                                    </span>
                                    {isCorrect && (
                                        <span
                                            title="Correct Answer"
                                            style={{
                                                marginLeft: 10,
                                                color: "#43a047",
                                                fontWeight: 700,
                                                fontSize: 20,
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                        >
                                            <i className="material-symbols-outlined" style={{ fontSize: 22 }}>check_circle</i>
                                        </span>
                                    )}
                                    <div style={{ display: "flex", gap: 1, marginLeft: "auto" }}>
                                        <button
                                            className="btn btn-sm btn-link p-0"
                                            style={{ fontSize: 16, minWidth: 40, color: "#757575" }}
                                            title="Edit"
                                            onClick={() => {
                                                setEditOptionId(`${qId}_${optionId}`);
                                                setEditOptionText(text);
                                            }}
                                        >
                                            <i className="ri-edit-2-fill"></i>
                                        </button>
                                        <button
                                            className="btn btn-sm btn-link text-danger p-0"
                                            style={{ fontSize: 16, minWidth: 40 }}
                                            title="Delete"
                                            onClick={() => {
                                                if (window.confirm("Are you sure you want to delete this option?")) {
                                                    getQuestionOptionDeleteApi(qId, optionId);
                                                }
                                            }}
                                        >
                                            <i className="ri-delete-bin-6-fill"></i>
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
                {/* Add Option UI */}
                {addOptionQuestionId === qId ? (
                    <div className="option-pill-new d-flex align-items-center mt-2" style={{
                        background: "#ffffff",
                        border: "2px dashed #bdbdbd",
                        padding: "8px 12px",
                        borderRadius: 6
                    }}>
                        <input
                            type="text"
                            className="form-control"
                            value={addOptionText}
                            onChange={e => setAddOptionText(e.target.value)}
                            style={{ maxWidth: 180, marginRight: 8 }}
                            placeholder="Enter new option"
                        />
                        <button
                            className="btn btn-sm btn-success me-1"
                            onClick={() => {
                                getQuestionOptionAddUpdateApi(qId, null, addOptionText, "add");
                                setAddOptionQuestionId(null);
                                setAddOptionText("");
                            }}
                        >
                            <i className="ri-add-line"></i>
                        </button>
                        <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => {
                                setAddOptionQuestionId(null);
                                setAddOptionText("");
                            }}
                        >
                            <i className="ri-close-line"></i>
                        </button>
                    </div>
                ) : (
                    <button
                        className="btn btn-sm btn-link p-0 mt-2"
                        style={{ color: "#757575" }}
                        onClick={() => setAddOptionQuestionId(qId)}
                    >
                        <i className="ri-add-line"></i> Add Option
                    </button>
                )}
            </div>
        );
    };

    // Question block rendering with grey question text
    const renderQuestionBlock = (purpose, questions, type, grade, classData) => {
        if (!questions || !questions.length) return null;
        return (
            <div className="question-block-new mb-4">
                <div className="d-flex align-items-center mb-2">
                    <span
                        className="material-symbols-outlined"
                        style={{
                            fontSize: 26,
                            color: questionTypeColors[type],
                            marginRight: 12,
                            background: "#fff",
                            borderRadius: "50%",
                            boxShadow: "0 2px 8px #1976d233",
                            padding: 6
                        }}
                    >
                        {type === "MCQ" ? "quiz" : type === "SAQ" ? "short_text" : type === "LAQ" ? "subject" : "help"}
                    </span>
                    <span style={{
                        fontWeight: 700,
                        color: questionTypeColors[type],
                        fontSize: 18,
                        letterSpacing: 1,
                        marginRight: 16
                    }}>
                        {typeLabels[type]}
                    </span>
                    <Badge bg="secondary" className="me-2 badge-topic" style={{ fontSize: 13 }}>
                        {questions[0]?.topic ? `Topic: ${questions[0].topic}` : "No Topic"}
                    </Badge>
                </div>
                <ul className="question-list m-0 p-0">
                    {questions.map((q, idx) => (
                        <li
                            className="d-flex mb-3 question-card-new"
                            key={idx}
                        >
                            {/* Serial Number */}
                            <div style={{
                                minWidth: 32,
                                height: 32,
                                background: "#f5f5f5",
                                color: "#757575",
                                fontWeight: 700,
                                fontSize: 16,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: 14,
                                border: "2px solid #e0e0e0"
                            }}>
                                {idx + 1}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div className="mb-1 d-flex align-items-center gap-2">
                                    {editQuestionId === q.id ? (
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editQuestionText}
                                            onChange={e => setEditQuestionText(e.target.value)}
                                            style={{ maxWidth: 400, marginRight: 8 }}
                                        />
                                    ) : (
                                        <span style={{ 
                                            fontSize: 16, 
                                            color: "#616161", // Grey color for question text
                                            fontWeight: 600 
                                        }}>
                                            {q?.question_text}
                                        </span>
                                    )}
                                </div>
                                {renderOptions(q?.mcq_options || q?.options, q.id)}
                            </div>
                            <div className="card-post-toolbar" style={{ marginLeft: 10 }}>
                                <Dropdown>
                                    <Dropdown.Toggle variant="bg-transparent" style={{ cursor: "pointer", padding: 0, border: "none" }}>
                                        <span className="material-symbols-outlined" style={{ fontSize: 22, color: "#757575" }}>
                                            more_horiz
                                        </span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="dropdown-menu-right">
                                        {editQuestionId === q.id ? (
                                            <>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        getQuestionUpdateApi(q.id, editQuestionText);
                                                        setEditQuestionId(null);
                                                    }}
                                                >
                                                    <i className="ri-save-line me-2"></i>Save
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => setEditQuestionId(null)}
                                                >
                                                    <i className="ri-close-line me-2"></i>Cancel
                                                </Dropdown.Item>
                                            </>
                                        ) : (
                                            <>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        setEditQuestionId(q.id);
                                                        setEditQuestionText(q.question_text);
                                                    }}
                                                >
                                                    <i className="ri-edit-2-fill me-2"></i>Edit
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => getQuestionDeleteApi(q?.id)}
                                                >
                                                    <i className="ri-delete-bin-6-fill me-2"></i>Delete
                                                </Dropdown.Item>
                                            </>
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        );
    };


    return (
        <>
            <div id='content-page' className='content-page'>
                <Container>
                    <Row>
                        <Col lg={12}>
                            {aiResponseList.length > 0 ?
                                <Card className="border-0 shadow-none">
                                    <div className="card-header d-flex justify-content-between align-items-center grade-header">
                                        <div className="header-title">
                                            <h4 className="card-title mb-0" style={{ fontWeight: '500' }}>Test List</h4>
                                        </div>
                                    </div>
                                    <Card.Body >
                                        <Accordion defaultActiveKey={null} alwaysOpen>
                                            {aiResponseList.map((grade, gradeIdx) => (
                                                <Accordion.Item eventKey={String(gradeIdx)} key={gradeIdx} className="grade-block  mb-4 rounded-3 border-0">
                                                    <Accordion.Header>
                                                        <span className="grade-label ">
                                                            <i className="material-symbols-outlined me-2 " style={{ fontSize: 24 }}>cast_for_education</i>
                                                            {grade?.grade_name}
                                                        </span>
                                                    </Accordion.Header>
                                                    <Accordion.Body style={{ borderRadius: 12 }}>
                                                        {grade?.classes?.map((classData, classIdx) => (
                                                            <Accordion key={classIdx} className="mb-3 class-block-accordion" defaultActiveKey={null} alwaysOpen>
                                                                <Accordion.Item eventKey={String(classIdx)} className="class-block border-0  rounded-3">
                                                                    <Accordion.Header>
                                                                        <span className="class-label d-flex align-items-center" >
                                                                            <i className="material-symbols-outlined me-2 " style={{ fontSize: 24 }}>school</i>
                                                                            {classData?.class_name}
                                                                        </span>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body style={{ borderRadius: 10 }}>
                                                                        <div className="class-inner-bg">
                                                                            {classData?.searches?.filter(search =>
                                                                                (search?.questions?.mcqs && search.questions.mcqs.length > 0) ||
                                                                                (search?.questions?.saqs && search.questions.saqs.length > 0) ||
                                                                                (search?.questions?.laqs && search.questions.laqs.length > 0) ||
                                                                                (search?.questions?.nonWeighted && search.questions.nonWeighted.length > 0)
                                                                            ).map((search, searchIdx) => (
                                                                                <Accordion key={searchIdx} className="mb-2" defaultActiveKey={null} alwaysOpen>
                                                                                    <Accordion.Item eventKey={String(searchIdx)} className="border-0 shadow-sm rounded-3">
                                                                                        <Accordion.Header>
                                                                                            <div className="d-flex flex-wrap align-items-center justify-content-between w-100" style={{ gap: 12 }}>
                                                                                                <div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
                                                                                                    <Badge bg="primary" style={{ fontSize: 14, fontWeight: 500 }}>
                                                                                                        {search?.purpose || "-"}
                                                                                                    </Badge>
                                                                                                    <Badge bg="info" style={{ fontSize: 14, fontWeight: 500 }}>
                                                                                                        {search?.topic || "-"}
                                                                                                    </Badge>
                                                                                                    {search?.test_details && (
                                                                                                        <>
                                                                                                            <Badge bg="light" text="dark" style={{ fontSize: 13 }}>
                                                                                                                <i className="material-symbols-outlined" style={{ fontSize: 16, verticalAlign: "middle" }}>calendar_month</i>
                                                                                                                &nbsp;Test Date:&nbsp;
                                                                                                                <span style={{ fontWeight: 500 }}>
                                                                                                                    {search.test_details.test_date}
                                                                                                                </span>
                                                                                                            </Badge>
                                                                                                            <Badge bg="warning" text="dark" style={{ fontSize: 13 }}>
                                                                                                                <i className="material-symbols-outlined" style={{ fontSize: 16, verticalAlign: "middle" }}>star</i>
                                                                                                                &nbsp;Marks: {search?.test_details?.exam_score}
                                                                                                            </Badge>
                                                                                                            <Badge bg="secondary" style={{ fontSize: 13 }}>
                                                                                                                <i className="material-symbols-outlined" style={{ fontSize: 16, verticalAlign: "middle" }}>timer</i>
                                                                                                                &nbsp;{search?.test_details?.test_duration} min
                                                                                                            </Badge>

                                                                                                        </>
                                                                                                    )}
                                                                                                </div>
                                                                                                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                                                                                    {search?.test_details && (
                                                                                                        <>
                                                                                                            <button
                                                                                                                className="btn btn-sm btn-outline-primary"
                                                                                                                style={{ fontSize: 13, padding: "2px 10px" }}
                                                                                                                title="Change Test Date"
                                                                                                                onMouseDown={e => e.preventDefault()}
                                                                                                                onClick={e => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleTestDateChange(search);
                                                                                                                }}
                                                                                                            >
                                                                                                                <i className="ri-edit-2-fill"></i> Change Date
                                                                                                            </button>
                                                                                                            <button
                                                                                                                className={`btn btn-sm ${search.test_details.is_publish ? "btn-success" : "btn-outline-danger"}`}
                                                                                                                style={{ fontSize: 13, padding: "2px 10px" }}
                                                                                                                title={search.test_details.is_publish ? "Unpublish" : "Publish"}
                                                                                                                onMouseDown={e => e.preventDefault()}
                                                                                                                onClick={e => {
                                                                                                                    e.stopPropagation();
                                                                                                                    homeworkPublishApi(
                                                                                                                        search.ai_search_id,
                                                                                                                        search.test_details.test_date,
                                                                                                                        search.test_details.is_publish ? 0 : 1
                                                                                                                    );
                                                                                                                }}
                                                                                                            >
                                                                                                                <i className="material-symbols-outlined" style={{ fontSize: 16, verticalAlign: "middle" }}>
                                                                                                                    {search.test_details.is_publish ? "check_circle" : "cancel"}
                                                                                                                </i>
                                                                                                                &nbsp;{search.test_details.is_publish ? "Published" : "Draft"}
                                                                                                            </button>
                                                                                                            <button
                                                                                                                className="btn btn-sm btn-outline-danger"
                                                                                                                style={{ fontSize: 13, padding: "2px 10px" }}
                                                                                                                title="Delete Test"
                                                                                                                onClick={e => {
                                                                                                                    e.stopPropagation();
                                                                                                                    if (window.confirm("Are you sure you want to delete this test?")) {
                                                                                                                        getTestDeleteApi(search.ai_search_id);
                                                                                                                    }
                                                                                                                }}
                                                                                                            >
                                                                                                                <i className="material-symbols-outlined" style={{ fontSize: 18, verticalAlign: "middle" }}>delete</i>
                                                                                                            </button>
                                                                                                            <button
                                                                                                                className="btn btn-sm btn-outline-secondary"
                                                                                                                style={{ fontSize: 13, padding: "2px 10px" }}
                                                                                                                title="Print Test"
                                                                                                                onClick={e => {
                                                                                                                    e.stopPropagation();
                                                                                                                    getTestPrintApi(search.ai_search_id);
                                                                                                                }}
                                                                                                            >
                                                                                                                <i className="material-symbols-outlined" style={{ fontSize: 18, verticalAlign: "middle" }}>print</i>
                                                                                                            </button>
                                                                                                        </>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </Accordion.Header>
                                                                                        <Accordion.Body style={{ borderRadius: 8 }}>
                                                                                            {renderQuestionBlock(search?.purpose, search?.questions?.mcqs, "MCQ", grade, classData)}
                                                                                            {renderQuestionBlock(search?.purpose, search?.questions?.saqs, "SAQ", grade, classData)}
                                                                                            {renderQuestionBlock(search?.purpose, search?.questions?.laqs, "LAQ", grade, classData)}
                                                                                            {renderQuestionBlock(search?.purpose, search?.questions?.nonWeighted, "NWQ", grade, classData)}
                                                                                        </Accordion.Body>
                                                                                    </Accordion.Item>
                                                                                </Accordion>
                                                                            ))}
                                                                            {/* Create New Question Button */}
                                                                            <li
                                                                                className="d-flex align-items-center create-question-btn"
                                                                                onClick={() => navigate('/dashboard/app/teachers-helper', {
                                                                                    state: {
                                                                                        typeParam: 2,
                                                                                        purposeParam: "Test",
                                                                                        gradeParam: grade || {},
                                                                                        classParam: classData || {},
                                                                                    }
                                                                                })}
                                                                            >
                                                                                <div className="d-flex align-items-center" style={{ width: "100%" }}>
                                                                                    <span className="material-symbols-outlined create-question-icon">
                                                                                        add_circle
                                                                                    </span>
                                                                                    <div>
                                                                                        <h6 className="create-question-title">
                                                                                            Create New Test
                                                                                        </h6>
                                                                                        <div className="create-question-desc">
                                                                                            Click here to add a new question for <b>{classData?.class_name}</b>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </div>
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>
                                                        ))}
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            ))}
                                        </Accordion>
                                        <InView as="div" onChange={(inView, entry) => loadMore(inView)} />
                                    </Card.Body>
                                </Card>
                                : <NoDataFound txtData="No results found yet!" />
                            }
                            {showMoreDataLoader ?
                                <div className="col-sm-12 text-center">
                                    <img src={loader} alt="loader" style={{ height: "100px" }} />
                                </div> : null
                            }
                            {showShareModal ?
                                <ShareModal handleClose={handleClose} classId={classId} data={shareModalData} />
                                : null
                            }
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default QuestionsList